import k from "./kaplayCtx";
import { loadAllAssets } from "./config/assets";
import { getAuthManager } from "../shared/systems/auth";
import intro from "./scenes/intro";
import menu from "./scenes/menu";

loadAllAssets(k);

// Unlock AudioContext on user gesture (required by mobile browsers, especially iOS Safari).
function unlockAudio() {
  const ctx = k.audioCtx;
  if (!ctx) return;
  if (ctx.state === "running") {
    document.removeEventListener("touchstart", unlockAudio, true);
    document.removeEventListener("touchend", unlockAudio, true);
    document.removeEventListener("mousedown", unlockAudio, true);
    return;
  }
  ctx.resume();
  const buf: AudioBuffer = ctx.createBuffer(1, 1, 22050);
  const src: AudioBufferSourceNode = ctx.createBufferSource();
  src.buffer = buf;
  src.connect(ctx.destination);
  src.start(0);
}
document.addEventListener("touchstart", unlockAudio, true);
document.addEventListener("touchend", unlockAudio, true);
document.addEventListener("mousedown", unlockAudio, true);

k.scene("intro", intro);
k.scene("menu", menu);

getAuthManager().init().then(() => k.go("intro"));
